module.exports = __webpack_public_path__ + "img/sld_scb_36_t1_b1_green.7dae4f11.svg";